(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('mouseover', (e) => {
    const swatch = e.target.closest('.pc-swatch--card[data-img]');
    if (!swatch) return;
    const gallery = swatch.closest('.card-gallery');
    if (!gallery) return;
    const preview = gallery.querySelector('.pc-img-preview');
    if (!preview) return;
    preview.src = swatch.dataset.img;
    preview.classList.add('pc-img-preview--visible');
  });

  document.addEventListener('mouseout', (e) => {
    const swatch = e.target.closest('.pc-swatch--card[data-img]');
    if (!swatch) return;
    const gallery = swatch.closest('.card-gallery');
    if (!gallery) return;
    const preview = gallery.querySelector('.pc-img-preview');
    if (!preview) return;
    preview.classList.remove('pc-img-preview--visible');
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    // Horizontal accordion -> tabs: physically separate headers and contents into two sibling rows
  function destaniyaSetActiveTab(accordion, idx) {
    accordion.querySelectorAll('[data-tab-index]').forEach(function (el) {
      el.classList.toggle('is-active', el.dataset.tabIndex === String(idx));
    });
  }

  function destaniyaInitOneAccordion(accordion) {
    if (accordion.dataset.tabsArranged === 'true') return;
    accordion.dataset.tabsArranged = 'true';

    var details = accordion.querySelectorAll('accordion-custom details');
    if (!details.length) return;

    var headerRow = document.createElement('div');
    headerRow.className = 'tabs__header-row';

    var contentRow = document.createElement('div');
    contentRow.className = 'tabs__content-row';

    details.forEach(function (d, i) {
      var summary = d.querySelector('summary');
      var content = d.querySelector('.details-content');
      if (summary) {
        var header = document.createElement('div');
        header.className = 'tabs__header';
        header.dataset.tabIndex = i;
        header.innerHTML = summary.innerHTML;
        header.setAttribute('role', 'tab');
        header.setAttribute('tabindex', '0');
        headerRow.appendChild(header);
      }
      if (content) {
        var newContent = document.createElement('div');
        newContent.className = 'details-content';
        newContent.dataset.tabIndex = i;
        while (content.firstChild) newContent.appendChild(content.firstChild);
        contentRow.appendChild(newContent);
      }
    });

    accordion.appendChild(headerRow);
    accordion.appendChild(contentRow);
    accordion.classList.add('tabs-ready');

    headerRow.addEventListener('click', function (e) {
      var header = e.target.closest('.tabs__header');
      if (!header) return;
      // e.detail is the click count within the system dblclick interval.
      // Second click in a dblclick pair closes; first click (or solo click) activates.
      if (e.detail >= 2) {
        destaniyaSetActiveTab(accordion, -1);
      } else {
        destaniyaSetActiveTab(accordion, header.dataset.tabIndex);
      }
    });

    headerRow.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var header = e.target.closest('.tabs__header');
      if (!header) return;
      e.preventDefault();
      destaniyaSetActiveTab(accordion, header.dataset.tabIndex);
    });

    // Default: no tab open
    destaniyaSetActiveTab(accordion, -1);
  }

  function destaniyaTabsInit() {
    document.querySelectorAll('.accordion--horizontal').forEach(destaniyaInitOneAccordion);
  }

  if (!window.__destaniyaTabsInit) {
    window.__destaniyaTabsInit = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', destaniyaTabsInit);
    } else {
      destaniyaTabsInit();
    }
    document.addEventListener('shopify:section:load', destaniyaTabsInit);
    document.addEventListener('shopify:block:select', destaniyaTabsInit);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["popup-link"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;
    const anchor = link.getAttribute('href').slice(1);
    if (!anchor) return;
    const dialog = document.querySelector(`dialog-component[data-popup-anchor="${anchor}"]`);
    if (!dialog) return;
    e.preventDefault();
    dialog.showDialog();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ugc-media"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.ugc-media__video').forEach((video) => {
    video.muted = true;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play();
        } else {
          entry.target.pause();
        }
      });
    }, { threshold: 0.1 });
    observer.observe(video);
  });
  } catch(e) { console.error(e); }
})();

})();
